import React from "react";

import BaseAdmin from "./BaseAdmin"
import { Card, Row, Col,Input,InputNumber,Form,Popconfirm, Table, message } from "antd";
import {Auth, API} from "aws-amplify";


const EditableContext = React.createContext();

class EditableCell extends React.Component{
    getInput = () => {
        if (this.props.inputType === 'number') {
          return (<InputNumber />);
        }
        return (<Input />);
      };

    renderCell = ({ getFieldDecorator }) => {
        const {editing, dataIndex, title, inputType, record, index, children, ...restProps} = this.props;

        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                        rules: [
                            {
                            required: true,
                            message: `${title} requerido!`,
                            }
                        ],
                        initialValue: record[dataIndex],
                        })(this.getInput())}
                    </Form.Item>
                ) : (children)}
            </td>
        );
  };

  render() {
    return (<EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>);
  }
}

class Plans extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            loading:true,
            plans:[], // nombre del plan, monto del plan, dia de vencimiento
            editingKey:'',
            count: 0,
        };

        this.columns = [
            {
                title: "Plan",
                dataIndex: "plan",
                key: "plan",
                editable: false,
                width:"10%"
            },
            {
                title: "Precio del plan",
                dataIndex: "costo",
                key: "costo",
                editable: true,
                width:"15%"
            },
            {
                title: "Duracion (meses)",
                dataIndex: "plazo",
                key: "plazo",
                editable: true,
                width:"15%"
            },
            {
                title: "Medio de pago",
                dataIndex: "medio",
                key: "medio",
                editable: false,
                width:"15%"
            },
            {
                title: "Operacion",
                dataIndex:"operation",
                width:"20%",
                align:'center',
                render: (text, record) => {
                    const { editingKey } = this.state;
                    const editable = this.isEditing(record);
                    return editable ? (
                      <span>
                        <EditableContext.Consumer>
                          {form => (
                            <a href="#/"
                              onClick={() => this.save_plan(form, record.key)}
                              style={{ marginRight: 8 }}
                            >
                              Guardar
                            </a>
                          )}
                        </EditableContext.Consumer>
                        <Popconfirm title="Desea cancelar?" onConfirm={() => this.cancel(record.key)}>
                          <a href="#/">Cancelar</a>
                        </Popconfirm>
                      </span>
                    ) : (
                      <span>
                        <a href="#/" disabled={editingKey !== ''} onClick={() => this.edit(record.key)}>
                          Editar
                        </a>
                        {/*<a disabled={editingKey !== ''} onClick={() => this.handleDelete_plan(record.key)}>
                        / Eliminar
                    </a>*/}
                      </span>
                    )
                    ;
                  },
                },
              ];
            };

    isEditing = record => record.key === this.state.editingKey;

            componentDidMount() {
                Auth.currentSession()
                    .then(response => {
                        API.get(
                            'test',
                            '/taxes/planes',
                            {
                                headers: {
                                    Authorization: response.getIdToken().getJwtToken()
                                }
                            }
                        )
                            .then(response => {
                              let planes = response.map(plan => {
                                plan['key']=plan['planId']
                                return plan})
                                this.setState({ loading: false, plans: planes })
                            })
                            .catch(err => console.log(err))
                    })
            }

    /*handleDelete_plans = key => {
        const columns = [...this.state.plans];
        this.setState({ plans: columns.filter(item => item.key !== key), editingKey:''});
    };

    handleAdd_plan = () => {
         const { count, plans } = this.state;
         const newData = {
         key: count,
         nombre_plan: `Nueva categoria ${count}`,
         precio:`Nuevo maximo ${count}`,
         vencimiento: `Nuevo imp_bienes ${count}`,
         };

         this.setState({
         plans: [...plans, newData],
         count: count +1,
         editingKey:''
     });
     };*/

     cancel = () => {
        this.setState({ editingKey: '' });
      };

    save_plan(form, key) {
    form.validateFields((error, row) => {
        if (error) {

        return;
        }
        const newData = [...this.state.plans];
        const index = newData.findIndex(item => key === item.key);


        if (index > -1) {
             const item = newData[index];
             newData.splice(index, 1, {
              ...item,
             ...row,
             });
        this.setState({plans: newData, editingKey:'', loading:true});
        this.call_api(newData[index])
        };
    })
     };


     call_api(newData){
              Auth.currentSession()
              .then(session => {
                  API.put(
                      'test',
                      '/taxes/planes/'+newData.planId,
                      {
                          headers: {
                              Authorization: session.getIdToken().getJwtToken()
                          },
                          body: {
                              costo:newData.costo,
                              plazo:newData.plazo,
                          }
                      }
                  )
                  .then(response => {
                      message.success("Tabla de planes actualizada")
                      this.setState({loading:false})
                  })
                  .catch(err => {
                      message.error("Hubo un error actualizando los datos")
                      console.log(err)
                      this.setState({ loading: false })
                  })
              })
            }

          edit(key) {
            this.setState({ editingKey: key });
          }

          render() {
            const components = {
              body: {
                cell: EditableCell,
              },
            };

     const columns = this.columns.map(col => {
        if (!col.editable) {
           return col;
         }
         return {
           ...col,
            onCell: record => ({
             record,
             inputType: col.dataIndex==='categoria'?'text':'number',
             dataIndex: col.dataIndex,
             title: col.title,
             editing: this.isEditing(record),

           }),
         };
         });


        return(
            <BaseAdmin
                selected="plans"
            >

                <Row gutter={[8,8]}>
                <Col lg={24}>
                <Card
                    title={"Información de Planes"}>
                    <EditableContext.Provider value={this.props.form}>
                        <Table
                        components={components}
                        columns={columns}
                        dataSource={this.state.plans}
                        rowClassName={"editable-row"}
                        pagination={{
                                showSizeChanger: true,
                                pageSizeOptions: ['5', '10', '20', '50'],
                                defaultPageSize: 20,
                            onChange: this.cancel,
                                hideOnSinglePage: true
                            }}
                            loading={this.state.loading}
                            scroll={{ x: "max-content" }}
                        />
                    </EditableContext.Provider>
                        {/*<Button
                            onClick = {this.handleAdd_plan}>
                            Agregar categoria
                        </Button>*/}
                </Card>
                </Col>
                </Row>
            </BaseAdmin>
        );
    }
}
const EditableFormTable = Form.create()(Plans);

export default EditableFormTable;